import { Component } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';

class Pagination extends Component {
    handleClick = (e, pageNumber, pageSize) => {
        e.preventDefault();

        if (this.props.onClick) {
            this.props.onClick(pageNumber, pageSize);
        } else {
            const params = queryString.parse(this.props.location.search);
            params.page = pageNumber;

            if (pageNumber == 1) {
                delete params.page;
            }

            let qs = queryString.stringify(params);

            if (qs.length > 0) {
                qs = '?' + qs;
            }

            this.props.history.push(`${this.props.location.pathname}${qs}`);
        }
    };

    renderPage = (index, pageNumber) => {
        const { page, pageSize, totalPages } = this.props.pagination;
        let className = 'page-item';

        if (page == pageNumber) {
            className += ' active';
        }

        if (totalPages == 1) {
            return <div key={index}></div>;
        }

        return (
            <li className={className} key={index}>
                <a className="page-link" onClick={e => this.handleClick(e, pageNumber, pageSize)}>
                    {pageNumber}
                </a>
            </li>
        );
    };

    renderPrevious = () => {
        const { page, pageSize } = this.props.pagination;

        if (parseInt(page) <= 1) {
            return;
        }

        return (
            <li className="page-item">
                <a className="page-link" onClick={e => this.handleClick(e, parseInt(page) - 1, pageSize)}>
                    <span aria-hidden="true">&lt;</span>
                    <span className="sr-only">Previous</span>
                </a>
            </li>
        );
    };

    renderNext = () => {
        const { page, pageSize, totalPages } = this.props.pagination;

        if (parseInt(page) >= parseInt(totalPages)) {
            return;
        }

        return (
            <li className="page-item">
                <a className="page-link" onClick={e => this.handleClick(e, parseInt(page) + 1, pageSize)}>
                    <span aria-hidden="true">&gt;</span>
                    <span className="sr-only">Next</span>
                </a>
            </li>
        );
    };

    render() {
        const { page = 1, pageSize = 0, totalPages = 0, totalItems = 0, lastPage = 0 } = this.props.pagination;
        const { label = 'Pagination', showPrevNext = true } = this.props;
        const currentPage = parseInt(page);
        const pages = [];

        if (totalItems <= 1) return null;

        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }

        let next, prev;
        let clonedPages = [];

        if (pages.length > 10) {
            let to, from;

            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                to = 0;
                from = 10;
            } else if (currentPage + 4 >= totalPages) {
                to = totalPages - 9;
                from = totalPages;
            } else {
                to = currentPage - 5;
                from = currentPage + 4;
            }

            clonedPages = pages.slice(to, from - 1);
        } else {
            clonedPages = pages;
        }

        if (showPrevNext) {
            next = this.renderNext();
            prev = this.renderPrevious();
        }

        const from = (parseInt(page) - 1) * parseInt(pageSize) + 1;
        const to = parseInt(page) == parseInt(lastPage) ? parseInt(totalItems) : parseInt(from) - 1 + parseInt(pageSize);

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    alignContent: 'middle',
                    padding: 8
                }}
            >
                <div
                    style={{
                        flexGrow: '1'
                    }}
                >
                    <nav aria-label={label}>
                        <ul className={`pagination ${pageSize}`}>
                            {prev}
                            {/* Show first page if not included in the list */}
                            {!clonedPages.includes(pages[0]) ? this.renderPage(1, pages[0]) : null}
                            {/* Render all other pages */}
                            {clonedPages.map((item, index) => this.renderPage(index, item))}
                            {/* Show last page if not included in the list */}
                            {!clonedPages.includes(pages[pages.length - 1]) ? this.renderPage(pages.length - 1, pages[pages.length - 1]) : null}
                            {next}
                        </ul>
                    </nav>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'baseline'
                    }}
                >
                    {from} to {to} of {` ${totalItems} `}- show{' '}
                    <div style={{ margin: '0 5px' }}>
                        <select
                            value={pageSize || 15}
                            name="pageSize"
                            id="pageSize"
                            onChange={e => {
                                this.handleClick(e, 1, e.target.value);
                            }}
                        >
                            <option value="15">15</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Pagination);
